<template>
  <b-container fluid>
<!-- User Interface controls -->
    <template>
      <ListHeader />
    </template>
    <b-row>
      <b-col lg="6" class="my-4">
        <b-form-group
          label="Filter"
          label-for="filter-input"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="md"
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="cerca"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6" class="my-4 text-center">
        <b-button @click="exportUsers">
          <b-spinner v-if="exportingFlag" small type="grow"></b-spinner>
          Export USERs
        </b-button>
      </b-col>
    </b-row>

<!-- Main table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="headVariant"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      sort-icon-left
      stacked="md"
      show-empty
      :select-mode="selectMode"
      responsive="sm"
      ref="selectableTable"
      selectable
      @row-selected="onRowSelected"
      @filtered="onFiltered"
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <!-- A custom formatted header cell for field 'name' -->
      <template #head(selected)>
        <input type="checkbox" class="lg" @click.stop="toggleSelectAll" name="selectAll" v-model="selectAll">
      </template>
      <template #cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <!-- <template #cell(fullName)="row">
        {{ row.value.last }} {{ row.value.first }}
      </template> -->

      <template #cell(actions)="row" style="vertical-align: center">
        <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
          Profilo Utente
        </b-button>
        <!-- <span @click.prevent="disableUser(row.item.id, row.item.fullName)" class="material-icons">delete</span> -->
      </template>
    </b-table>

    <b-row>
      <b-col sm="5" md="6" class="my-1">
        <b-form-group
          label="Per page"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- <p>
      <b-button size="sm" @click="selectAllRows">Select all</b-button>
      <b-button size="sm" @click="clearSelected">Clear selected</b-button>
    </p>
    <p>
      Selected Rows:<br>
      {{ selected }}
    </p> -->

<!-- Info modal -->
    <b-modal :id="infoModal.id" class="scrollable" size="xl" ok-only ok-title="CHIUDI" ok-variant="secondary" @hide="resetInfoModal">
      <template #modal-header="{ close }">
        <b-container style="margin: auto; padding: 10px; background-color: #333; color: #FFF">
          <b-row> 
            <b-col>
              <img src="../../assets/logo.png" style="width: 160px;">
            </b-col>
            <b-col style="text-align: center; margin: auto;">
              <h3 >Profilo USER</h3>
            </b-col>
            <b-col style="float: right; margin: auto;">
              <span style="float: right; margin-right: 10px;" @click="close()">X</span>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <template>
        <UserDetail />
      </template>
    </b-modal>
  </b-container>
</template>

<script>
  import { firebaseApp } from '../../firebase/config.js';
  import ListHeader from '../ListHeader.vue';
  import UserDetail from './UserDetail.vue';
  import { mapGetters, mapMutations } from 'vuex';
  import { saveAs } from 'file-saver';

  export default {
    data() {
      return {
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        row: {},
        selectAll: false,
        isBusy: true,
        headVariant: 'dark',
        items: [],
        userData: {},
        userDogs: [],
        userSubs: [],
        fields: [
          { key: 'selected', label: 'Selected' },
          { key: 'fullName', label: 'Cliente',  sortable: true,  },
          { key: 'email', label: 'Email', sortable: true, },
          { key: 'phoneNumber', label: 'Telefono',  sortable: true,  },
          { key: 'actions', label: 'Azioni' }
        ],
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        exportingFlag: false,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: '',
        }
      }
    },
    created() {
      this.isBusy = true

      this.items = []
      const listOrgUsers = firebaseApp
        .functions('europe-west3')
        .httpsCallable('listOrgUsers');

      listOrgUsers('d37SloAGeFNnFkbWpHuq') //('CzEm4jjUh1GSV5j0ZbfA')
      .then((resp) => {
        //Save user data returned by API function on VUEX Store
        //console.log(resp.data.result);
        console.log(resp.data.result.code);
        //console.log(resp.data.result.users);
        this.items = resp.data.result.users
        this.isBusy = false
        //console.debug(this.items)
      })
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      totalRows() {
        return this.items.length
      },
      ...mapGetters({
          // map `this.sel_**` to `this.$store.getters._**`
          user: "user",
          sel_user: "_user",
          sel_card: "_card"
       })
    },
    methods: {
      onRowSelected(items) {
        this.selected = items
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      toggleSelectAll() {
        this.selectAll = !this.selectAll
        if(this.selectAll) {
          this.selectAllRows()
        } else {
          this.clearSelected()
        }
      },
      info(item, index, button) {
        this.infoModal.title = `Profilo Utente`
        this.set_sel_user({
                  id: item.uid,
                  fullName: item.fullName,
               });
        console.log('sel_user ->', this.sel_user)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      disableUser(id, userFullName){
        if (window.confirm(`Vuoi disattivare lo USER ${id} - ${userFullName} ?`)) {
        /*  
          //disable USER's CARDs
          ...........
          //disable Auth USER
          ...........
          //disable USER
          db.collection("users").doc(id).set({isActive: false}).then(() => {
            console.log(`USER ${userFullName} bloccato!`);
          })
          .catch((error) => {
            console.error(error);
          })*/
        }
      },
      exportUsers() {
        this.exportingFlag = true
        const exportUsers = firebaseApp
        .functions('europe-west3')
        .httpsCallable('exportUsers')
        
        exportUsers('d37SloAGeFNnFkbWpHuq')
        .then((result) => {
          console.log('result', result)

          const blob = new Blob([result.data.csv], { type: 'text/csv;charset=utf-8;' });
          saveAs(blob, 'data.csv');

          this.exportingFlag = false
          
          // conversion to reAdjust old accounts with missing fields on db
          // const users = result.data.usersIncomplete
          // const setUser = firebaseApp
          //   .functions('europe-west3')
          //   .httpsCallable('setUser');
          
          // for (let i = 0; i < users.length; i++) {  
          //   const displayName = users[i].name + ' ' + users[i].surname
          //   const fullname = users[i].surname + ' ' + users[i].name
          //   const userData = {
          //     ...users[i],
          //     displayName: displayName,
          //     fullname: fullname
          //   }
          //   console.log('user to complete:', userData)
            
          //   setTimeout(() => {
          //     setUser(userData)
          //     .then((resp) => {
          //       //console.log(resp.data.result);
          //       //console.log(resp.data.result.userId);
          //       console.log(resp.data.result.displayName);
          //     })
          //   }, 3000);
            
          // }
        })
      },
      ...mapMutations({
        set_sel_user: 'SET_SEL_USER', // map `this.set_sel_user()` to `this.$store.commit('SET_SEL_USER')`
        set_sel_card: 'SET_SEL_CARD'
      })
    },
    components: {
      //Login,
      ListHeader,
      UserDetail,
    }
  };
</script>
<!-- css at bottom of page -->
<style lang="scss" scoped>

.scrollable {
  max-width: 80vw;
  overflow-x: auto;
}
</style>